import { isStandardBrowserEnv } from '@dimjs/lang';
import { utils } from '../../utils/index.js';
import { fabric } from './api.js';
import { bootstrap } from './bootstrap.js';

// Auto boostrap bridge engine.
(function () {
  if (isStandardBrowserEnv()) {
    const { webview, log } = utils;
    if (webview.isFabricWebview() && webview.isHarmony()) {
      // Load bridge core in `harmony` webview.
      log.logData('Load bridge core in `harmony` webview...');
      // Bootstrap brige infrastructure
      bootstrap(fabric);
    }
  }
})();

export const fabricHarmony = fabric;
